export default {
  root: '/',
  form: '/form',
  summary: '/summary',
  payment: '/payment',
  paymentConfirmation: '/payment-confirmation',
  demo: '/demo/calendar',
  paymentLoading: '/payment-loading',
};
